import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';

class Textarea extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            show: true,
            value: "",
            textRemaining: "",
            touched: false,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : null;
        if (nextData && nextData[nextProps.control.key] === undefined && prevState.touched) {
            return {
                value: '',
                touched: false
            };
        } else if (nextData) {
            return {
                value: nextData[nextProps.control.key]
            };
        }
        else return null; // Triggers no change in the state
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.value && this.state.value === undefined && this.state.touched === false) {
            this.props.update(this.props.control.key, this.state.value, this.props.formid)
        } else if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    componentDidMount() {
        this.setState({ touched: this.state.value ? true : false });

        ControlService().controlVaildationCheck(this.props);
    }
    toggle() {
        this.setState({
            show: !this.state.show
        });
    }
    azureTextAnalysis() {
        const { control, formid, token } = this.props;
        debugger;
        if (control.enableazuretextanalysis) {
            let _control = {
                datasource: 'http',
                method: 'post'
            }
            ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + "/api/azure/textanalytics/" + control.textanalysistype, { fnname: control.textanalysistype }, _control, token, { data: this.state.value })
                .then(
                    (res) => {
                        this.props.update(control.textanalysisresponsekey ? control.textanalysisresponsekey : (control.key + '_textanalysis'), res.data, formid)
                    })
                .catch(err => {
                    console.log(err);
                });
        }
    }
    onValueChange(value, control, action, formid) {
        if (action == 'filter') {
            this.props.updateFilter(control.key, value)
        }
        else {
            this.props.update(control.key, value, formid)
        }
        var validation = ControlService().validate(control, value);
        var formValidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
        if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }
        if (control.textanalysison === 'onblur') {
            this.azureTextAnalysis();
        }
    }
    handleBlur = () => {
        if (this.props.control.textanalysison === 'onblur') {
            this.azureTextAnalysis();
        }
        this.setState({
            touched: true,
        });
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;

        return validate ? !validate : shouldShow;
    }
    render() {
        var show = {
            display: this.state.show ? "block" : "none"
        };

        var hidden = {
            display: this.state.show ? "none" : "block"
        }
        const { control, action, formid } = this.props;
        const { value } = this.state;
        let textRemaining = (control.Textlimit - (value ? value.length : 0));
        const shouldMarkError = this.shouldMarkError(control, value);
        return (
            <div>
                {!control.isPanel ?
                    <div className="form-group">
                        {control.label &&
                            <label htmlFor={control.id}>
                                {control.label}
                                {control.require &&
                                    <sup className="text-danger font-weight-bold">*</sup>
                                }
                                {control.showhelptext &&
                                    <span className={"custom-tooltip"}>
                                        <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                        <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                    </span>
                                }
                            </label>
                        }
                        <textarea
                            id={control.id}
                            onBlur={() => { this.handleBlur(); }}
                            className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                            placeholder={control.placeholder}
                            onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                            value={value}
                            style={{ height: control.height + 'px' }}
                            disabled={this.props.disabled}
                        ></textarea>
                        {
                            (control.enableazuretextanalysis && (control.textanalysison === 'click' || control.textanalysison == '')) &&
                            <button aria-label='Azure Text Analysis' className="btn btn-primary" title="Azure Text Analysis" onClick={() => this.azureTextAnalysis()}><i className="fa fa-recycle"></i></button>
                        }
                        {shouldMarkError &&
                            <small className="form-text text-danger">
                                {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                            </small>
                        }
                        {(control.Textlimit) && <span className="form-text text-secondary">{textRemaining} character(s) remaining</span>}
                        {(control.Textlimit && textRemaining < 0) && <span className="form-text text-danger">Maximum ammount of character(s) allowed: {control.Textlimit} ,</span>}
                        {(control.Textlimit && textRemaining < 0) && <span className="form-text text-danger">Remove {textRemaining} character(s)</span>}
                    </div>
                    :
                    <div className="card form-group">
                        <div className="card-header d-flex align-items-center pointer" onClick={this.toggle.bind(this)}>
                            <div className="m-0">
                                {control.label}
                                {control.require &&
                                    <sup className="text-danger font-weight-bold">*</sup>
                                }
                                {control.showhelptext &&
                                    <span className={"custom-tooltip"}>
                                        <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                        <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                    </span>
                                }
                            </div>
                            <span className="ml-auto" style={hidden}><i className="fa fa-angle-down pl-2" aria-hidden="true"></i></span>
                            <span className="ml-auto" style={show}><i className="fa fa-angle-up pl-2" aria-hidden="true"></i></span>
                        </div>
                        {this.state.show &&
                            <div className="card-body">
                                <div>
                                    <textarea autoComplete="off"
                                        onBlur={() => { this.handleBlur(); }}
                                        className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                                        placeholder={control.placeholder}
                                        onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                                        value={value}
                                        style={{ height: control.height + 'px' }}
                                        disabled={this.props.disabled}
                                    ></textarea>
                                    {shouldMarkError &&
                                        <small className="form-text text-danger">
                                            {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                                        </small>
                                    }
                                    {/* {shouldMarkError &&
                                            <small className="form-text text-danger">
                                                No space allowed.
                                            </small>
                                        } */}
                                    {(control.Textlimit && textRemaining) && <span className="form-text secondary-text">{textRemaining} character(s) Remaining</span>}
                                    {(control.Textlimit && textRemaining < 0) && <span className="form-text secondary-text">Maximum ammount of Character(s) allowed: {control.Textlimit} ,</span>}
                                    {(control.Textlimit && textRemaining < 0) && <span className="form-text secondary-text">remove {textRemaining} Character(s)</span>}
                                </div>
                            </div>
                        }
                    </div>
                }

            </div >
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value) => dispatch(updateFilterData(key, value))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});
export default connect(mapStateToProps, bindAction)(Textarea);